import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Ordine, TIPO_ORDINE} from "../../../models/Ordine";
import {ActivatedRoute, Router} from "@angular/router";
import {DxService} from "../../../services/dx.service";
import {ServerService} from "../../../services/server.service";
import {DialogService} from "../dialog/dialog.service";
import {DxDataGridComponent} from "devextreme-angular";
import moment from "moment/moment";

@Component({
   selector: 'app-tabella-rettifiche',
   templateUrl: './tabella-rettifiche.component.html',
   styleUrls: ['./tabella-rettifiche.component.scss']
})
export class TabellaRettificheComponent implements OnInit {
   @ViewChild('grid') grid!:DxDataGridComponent

   @Input() tipoRettifica
   @Input() vendorSlug;
   @Input() pVenditaId = null;
   @Input() isAmmanco = false;

   Ordine = Ordine;
   headerFilterStatoData: any;
   moment = moment;


   constructor(private router: Router,
               private route: ActivatedRoute,
               private dxSrv: DxService,
               private serverSrv: ServerService,
               private dialogSrv: DialogService,
   ) {
      this.headerFilterStatoData = Ordine.HeaderFilterStatoData

   }

   ngOnInit(): void {
   }

   ngAfterViewInit(): void {
      this.initGrid()
   }

   ngOnDestroy(): void {
   }

   initGrid(){
      let tipo = TIPO_ORDINE.AMMANCO
      if (!this.isAmmanco) tipo = TIPO_ORDINE.ESUBERO
      this.dxSrv.initGrid(this.grid, {showAdd:true, onClickNew: () => {
            this.createNewRettifica(tipo)
         }})
      this.dxSrv.gridCreateDataSource(`/api/esercizi/${this.vendorSlug}/p_vendita/${this.pVenditaId}/rettifiche?tipo=${tipo}`, this.grid)
   }

   createNewRettifica(tipo){
      this.serverSrv.post(`/api/esercizi/${this.vendorSlug}/p_vendita/${this.pVenditaId}/rettifiche?tipo=${tipo}`, {tipo:TIPO_ORDINE.AMMANCO}, Ordine).then(res => {
         this.router.navigate([res.data.id], {relativeTo:this.route})
         this.dialogSrv.showToastSuccess({title:this.isAmmanco ? "Nuovo Ammanco" : "Nuovo Esubero", msg:this.isAmmanco ? "Nuovo Ammanco creato" : "Nuovo esubero creato"})
         console.log(res)
      }).catch(err => {
         console.error(err)
      })
   }

   clickOpenOrder(id){
      this.router.navigate([id], {relativeTo: this.route});
   }

   clickEliminaRettifica(item) {
      console.log(item)
      let url = `/api/esercizi/${this.vendorSlug}/p_vendita/${this.pVenditaId}/rettifiche/${item.data.id}?tipo=${item.data.tipo}`
      // if (!this.isAmmanco)  url = `/api/esercizi/${this.vendorSlug}/p_vendita/${this.pVenditaId}/esuberi/${id}`
      //
      this.dialogSrv.showConfirm({title:"Elimina Ammanco", msg:"Attenzione! Vuoi davvero eliminare la rettifica? Se confermi verranno ripristinate le quantità dei prodotti presenti nella rettifica. Vuoi continuare?"}).then(() => {
         this.serverSrv.delete(url, {}, null).then(res => {
            console.log(res)
            this.grid.instance.refresh()
            this.dialogSrv.showToastSuccess({title:"Elimina Rettifica", msg:"Rettifica eliminata"})
         }).catch(err => {
            this.dialogSrv.showToastError({title:"Elimina Rettifica", err:err})
            console.log(err)
         })
      })
   }

}
